import React from 'react';
import { Box, Typography } from '@mui/material';
import IncidentTab from './IncidentTab';

/**
 * OpsCenter — Major Incidents: ServiceNow incident summary and trends (single view; Alerts tab removed).
 */
const OpsCenter = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#1D4434' }}>
        Major Incidents
      </Typography>

      <IncidentTab />
    </Box>
  );
};

export default OpsCenter;
